import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AppComponent } from 'app/app.component';
import { MenuPermissionConfig, MenuPermissionActionEnum } from 'app/models';
import { MenuHomeEnum } from 'app/components/home';

export enum PartnerDashboardMenuEnum {
    Dashboard = 1
}

@Component({
    selector: 'partner-dashboard-root',
    templateUrl: './partner-dashboard-root.component.html',
    styleUrls: ['./partner-dashboard-root.component.scss'],
    providers: [MessageService]
})
export class PartnerDashboardRootComponent implements OnInit {
    public menuEnum = MenuHomeEnum;
    public activeMenu: MenuHomeEnum = MenuHomeEnum.PartnerDashboard;

    public menuPermissionConfig = MenuPermissionConfig;
    public menuPermissionActionEnum = MenuPermissionActionEnum;

    public menuPermissionActive!: string;

    constructor(private messageService: MessageService, public app: AppComponent) { }

    ngOnInit(): void { }

    public clickMenu(menuPermissionActive: string, menu: MenuHomeEnum) {
        this.menuPermissionActive = menuPermissionActive;
        this.activeMenu = menu;
    }
}
